module.exports = __webpack_public_path__ + "static/intro-c456007a1c9f97bfdbd321c0e22cd48c.webm";